<template>
    <div class="not-found">
        <img src="@assets/img/404-icon.svg" alt="404 Image">
        <h1>Invalid Information</h1>
        <p>We couldn't find the page you're looking for.</p>
    </div>
</template>

<script>
export default {
    name: "NotFound",
    metaInfo: {
        titleTemplate: "Page Not Found - hibooks"
    }
}
</script>

<style lang="scss" scoped>
.not-found {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 0 20px;

    img {
        margin-bottom: 20px;
    }

    h1 {
        color: white;
        font-size: 24px;
        font-weight: 600;
        line-height: 33px;
        margin-bottom: 10px;
    }

    p {
        font-size: 18px;
        line-height: 24px;
        color: white;
    }
}
</style>
